// import React from "react";
// import { FormControl, InputLabel, MenuItem, Select, FormHelperText, TextField, InputAdornment } from "@mui/material";


// interface DropdownOption {
//     label: string;
//     value: string;
// }

// interface DropdownFieldProps {
//     label: string;
//     name: string;
//     value: string;
//     onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
//     options: DropdownOption[];
//     required?: boolean;
//     showError?: boolean;
//     helperText?: string;
// }

// const DropdownFieldProps : React.FC<DropdownFieldProps> = ({
//     label,
//     name,
//     value,
//     onChange,
//     options,
//     required = false,
//     showError = false,
//     helperText = "",
// }) => {
//     return (
//     <TextField
//         select
//         fullWidth
//         label={label}
//         name={name}
//         value={value}
//         onChange={onChange}
//         required={required}
//         error={showError}
//         helperText={showError ? helperText : ""}
//         >
//         <MenuItem value="">
//             <em>None</em>
//         </MenuItem>
//         {options.map((option) => (
//             <MenuItem key={option.value} value={option.value}>
//             {option.label}
//             </MenuItem>
//         ))}
//     </TextField>
//   );
// };
// export default DropdownFieldProps;

import React from "react";
import {
  TextField,
  MenuItem,
  InputAdornment,
  TextFieldProps,
} from "@mui/material";

interface DropdownOption {
  label: string;
  value: string;
}

interface DropdownFieldProps extends Omit<TextFieldProps, "onChange" | "select"> {
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: DropdownOption[];
  icon?: React.ReactNode;
  showError?: boolean;
  helperText?: string;
  placeholder?: string;
}

const DropdownField: React.FC<DropdownFieldProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  required,
  icon,
  showError,
  helperText,
  placeholder,
  ...rest
}) => {
  return (
    <TextField
      select
      fullWidth
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      error={showError}
      helperText={showError ? helperText : ""}
      placeholder={placeholder}
      InputProps={{
        startAdornment: icon ? (
          <InputAdornment position="start">{icon}</InputAdornment>
        ) : undefined,
      }}
      {...rest}
    >
      {options?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default DropdownField;
